import React from 'react';

import Pagination from 'components/ui/pagination';

import { useTasks } from '../context/tasks_context';

interface Props {
  floating?: boolean;
}

export function TasksPagination({ floating }: Props) {
  const { pagination, setPage } = useTasks();

  if (!pagination || pagination.totalPages <= 1) return null;

  return (
    <Pagination
      currentPage={pagination.currentPage}
      floating={floating}
      totalPages={pagination.totalPages}
      onChange={setPage}
    />
  );
}
